exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8796b8de] .topImage{width:140px;height:140px}", ""]);

// exports
